module.exports = __webpack_public_path__ + "static/media/Family2+1.24758416.svg";